module.exports = __webpack_public_path__ + "static/media/bottom_sheet.eb152615.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom_sheet.svg
// module id = 867
// module chunks = 0